import styled from 'styled-components';

export const PricingTypeWrapper = styled.div`
  font-size: 12px;
  font-weight: 100;
`;
